module.exports = __webpack_public_path__ + "img/SES_191428800.1a7dedf6.jpg";